export default {
    'fr': require('./fr'),
    'nl': require('./nl'),
    'en': require('./en')
}